import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "select2";
import "select2/dist/css/select2.css";

// Site Key от Google reCAPTCHA v3
const RECAPTCHA_SITE_KEY = "6LfSkEwsAAAAAO2Bid3bSvs2xr47pfb-7tR6r4H0";

$(document).ready(function () {
  // Кастомный дропдаун
  const $dropdown = $(".contacts__dropdown");
  const $trigger = $dropdown.find(".contacts__dropdown-trigger");
  const $menu = $dropdown.find(".contacts__dropdown-menu");
  const $items = $dropdown.find(".contacts__dropdown-item");
  const $text = $dropdown.find(".contacts__dropdown-text");
  const $hiddenInput = $dropdown.find(".contacts__dropdown-value");

  // Открытие/закрытие дропдауна
  $trigger.on("click", function () {
    $dropdown.toggleClass("is-open");
  });

  // Выбор пункта
  $items.on("click", function () {
    const $item = $(this);
    const value = $item.data("value");
    const text = $item.text();

    $text.text(text);
    $hiddenInput.val(value);
    $dropdown.removeClass("is-open");
  });

  // Закрытие при клике вне дропдауна
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".contacts__dropdown").length) {
      $dropdown.removeClass("is-open");
    }
  });

  // Обработка отправки формы с reCAPTCHA v3
  const $contactForm = $("#contactForm");
  const $formStatus = $contactForm.find(".contacts__form-status");
  const $formSuccess = $contactForm.find(".contacts__form-success");
  const $submitBtn = $contactForm.find(".contacts__button");

  $contactForm.on("submit", function (e) {
    e.preventDefault();

    // Проверяем, что reCAPTCHA загружена
    if (typeof grecaptcha === "undefined") {
      showError("Ошибка загрузки капчи. Попробуйте обновить страницу.");
      return;
    }

    // Блокируем кнопку
    $submitBtn.prop("disabled", true).text("Отправка...");

    // Получаем токен reCAPTCHA
    grecaptcha.ready(function () {
      grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action: "submit_contact" })
        .then(function (token) {
          // Записываем токен в скрытое поле
          $("#recaptchaToken").val(token);

          // Собираем данные формы
          const formData = new FormData($contactForm[0]);

          // Отправляем форму
          fetch("/api/send-mail.php", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.success) {
                showSuccess();
                $contactForm[0].reset();
                $text.text("ТЕМА ПИСЬМА");
              } else {
                showError(data.message || "Ошибка отправки. Попробуйте позже.");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              showError("Ошибка отправки. Попробуйте позже.");
            })
            .finally(() => {
              $submitBtn.prop("disabled", false).text("Отправить");
            });
        })
        .catch(function (error) {
          console.error("reCAPTCHA error:", error);
          showError("Ошибка проверки капчи. Попробуйте позже.");
          $submitBtn.prop("disabled", false).text("Отправить");
        });
    });
  });

  // Показываем оверлей при успешной отправке
  function showSuccess() {
    $formSuccess.addClass("is-visible");
    setTimeout(() => {
      $formSuccess.removeClass("is-visible");
    }, 3000);
  }

  // Показываем ошибку
  function showError(message) {
    $formStatus.text(message).fadeIn();
    setTimeout(() => {
      $formStatus.fadeOut();
    }, 5000);
  }
});
